import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// Render outside the sticky/backdrop-filtered header so the viewport owns sizing.
export default function MobileDrawer({ title, onClose, children }) {
  const ref = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const dialog = ref.current;
    const previousFocus = document.activeElement;
    const overflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    return () => {
      dialog.close();
      document.body.style.overflow = overflow;
      previousFocus?.focus?.({ preventScroll: true });
    };
  }, []);
  return createPortal(<dialog ref={ref} aria-label={title} className="mobile-drawer"
    onCancel={event => { event.preventDefault(); close.current(); }}
    onClick={event => { if (event.target === ref.current) close.current(); }}>
    <aside className="mobile-drawer-panel">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="m-0 text-lg font-semibold">{title}</h2>
        <button type="button" aria-label={`Close ${title}`} onClick={onClose}
          className="min-h-[44px] min-w-[44px] rounded-lg border border-slate-200">×</button>
      </div>
      {children}
    </aside>
  </dialog>, document.body);
}
